var _Path, _Path2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgFinancial = function SvgFinancial(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#financial_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M28 21.055a2.78 2.78 0 0 1 2.778 2.778 1.389 1.389 0 1 0 2.778 0c0-2.58-1.777-4.737-4.167-5.358v-.198a1.389 1.389 0 1 0-2.778 0v.198c-2.39.62-4.166 2.778-4.166 5.358A5.56 5.56 0 0 0 28 29.389a2.78 2.78 0 0 1 2.778 2.777A2.78 2.78 0 0 1 28 34.944a2.78 2.78 0 0 1-2.778-2.778 1.388 1.388 0 1 0-2.777 0c0 2.58 1.776 4.738 4.166 5.359v.197a1.389 1.389 0 1 0 2.778 0v-.197c2.39-.621 4.167-2.778 4.167-5.359A5.56 5.56 0 0 0 28 26.611a2.78 2.78 0 0 1-2.778-2.778A2.78 2.78 0 0 1 28 21.055"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M28 8.555C17.278 8.555 8.555 17.278 8.555 28S17.278 47.444 28 47.444 47.444 38.722 47.444 28 38.722 8.555 28 8.555m0 36.112c-9.19 0-16.667-7.477-16.667-16.667S18.81 11.333 28 11.333 44.667 18.81 44.667 28 37.19 44.667 28 44.667"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M28 8.555C17.278 8.555 8.555 17.278 8.555 28S17.278 47.444 28 47.444 47.444 38.722 47.444 28 38.722 8.555 28 8.555m0 36.112c-9.19 0-16.667-7.477-16.667-16.667S18.81 11.333 28 11.333 44.667 18.81 44.667 28 37.19 44.667 28 44.667"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M53 28C53 14.215 41.785 3 28 3S3 14.215 3 28s11.215 25 25 25 25-11.215 25-25M28 50.222c-12.253 0-22.222-9.97-22.222-22.222S15.748 5.778 28 5.778 50.222 15.748 50.222 28 40.252 50.222 28 50.222"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M53 28C53 14.215 41.785 3 28 3S3 14.215 3 28s11.215 25 25 25 25-11.215 25-25M28 50.222c-12.253 0-22.222-9.97-22.222-22.222S15.748 5.778 28 5.778 50.222 15.748 50.222 28 40.252 50.222 28 50.222"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "financial_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M3 3h50v50H3z"
  })))));
};
export default SvgFinancial;